var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.168,
    y: 49.9609,
    width: 49.9609,
    height: 49.9609,
    rx: 24.9805,
    transform: "rotate(-180 50.168 49.9609)",
    fill: "#71879C",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_19014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0183 32.6784C23.9027 29.5295 19.9381 26.9649 17.0229 25.4497L17.0233 24.0501C19.9395 22.7662 23.7891 20.3157 23.7901 17.2833L25.8894 17.2827C26.0049 20.6649 22.5053 22.9986 20.0558 23.8159L33.1183 24.0448L33.1176 26.1442L20.0551 25.9152C22.6207 26.6141 26.2354 29.2954 26.1176 32.6777L24.0183 32.6784Z",
    fill: "#212727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_19014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8611,
    height: 12.5395,
    fill: "white",
    transform: "translate(25.3008 33.9609) rotate(-135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftRounded);
export default __webpack_public_path__ + "static/media/arrow-left-rounded.7d3f0da69847c043f8d58d05018955af.svg";
export { ForwardRef as ReactComponent };